import { render, staticRenderFns } from "./SublocalsView.vue?vue&type=template&id=8a35203e&"
import script from "./SublocalsView.vue?vue&type=script&lang=js&"
export * from "./SublocalsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports